import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, map } from 'rxjs/operators';

import { AppState } from 'src/app';

import { Subscription } from 'rxjs';

@Injectable()
export class LoremGuard implements CanActivate, CanActivateChild {
  loremUserSubscription: Subscription;
  isFromLorem = false;

  constructor(private router: Router, private store: Store<AppState>) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.resolveAuth()) {
      this.router.navigateByUrl('/main/portfolio');
      return false;
    } else {
      return true;
    }
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }

  private resolveAuth(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.loremUserSubscription = this.store
        .select('currentContract')
        .pipe(
          map((values: any) => values.toJS()),
          distinctUntilChanged(),
        )
        .subscribe((value: any) => {
          if (value && value.contractID) {
            this.isFromLorem = value.isLoremAccount;
          }
          resolve(this.isFromLorem);
        });
    });
  }
}
